<template>
  <sp-fieldset flex rowgap="0.5" direction="column">
    <sp-row justify="space-between">
      <sp-col>
        <sp-label>{{ name }}</sp-label>
      </sp-col>
      <sp-col align-items="end">
        <sp-switch
          :checked="model.locked"
          label="All Sides"
          label-prepend
          @update-checked="handleLockedChange"
        ></sp-switch>
      </sp-col>
    </sp-row>
    <div v-if="model.locked">
      <InputRangeSlider
        v-model="model.all"
        :default-value="defaultValue"
        :min="min"
        :max="max"
        :step="step"
        :unit="unit"
        :auto="auto"
        :value-and-unit-width="valueAndUnitWidthLocked"
        :value-button-width="valueButtonWidth"
      />
    </div>
    <sp-container v-else flex direction="column" rowgap="0.5">
      <sp-row v-for="position in positions" :key="position">
        <sp-col cols="2" class="position-label">{{ position }}: </sp-col>
        <sp-col>
          <InputRangeSlider
            v-model="model[position]"
            :default-value="defaultValue"
            :min="min"
            :max="max"
            :step="step"
            :unit="unit"
            :auto="auto"
            :value-and-unit-width="valueAndUnitWidth"
            :value-button-width="valueButtonWidth"
          />
        </sp-col>
      </sp-row>
    </sp-container>
  </sp-fieldset>
</template>

<script setup>
import { computed, watch } from "vue";
import { useBoxModelUI } from "../../../../composables/box-model-ui";
import InputRangeSlider from "../../InputRangeSlider.ce.vue";

const emit = defineEmits(["update:modelValue", "update:shortHand"]);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  defaultValue: {
    type: [Number, String],
    default: undefined,
  },
  min: {
    type: [Number, String],
    default: 0,
  },
  max: {
    type: [Number, String],
    default: 200,
  },
  step: {
    type: [Number, String],
    default: 1,
  },
  unit: {
    type: String,
    default: "px",
  },
  auto: {
    type: [Boolean, String],
    default: false,
  },
  valueAndUnitWidth: {
    type: String,
    default: "8ch",
  },
  valueButtonWidth: {
    type: String,
    default: "5ch",
  },
  valueAndUnitWidthLocked: {
    type: String,
    default: "8ch",
  },
});

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const { positions, setLocked, shortHand } = useBoxModelUI(model);

watch(shortHand, (value) => {
  emit("update:shortHand", value);
});

function handleLockedChange({ detail }) {
  const [value] = detail;
  setLocked(value);
}
</script>

<style lang="scss" scoped>
sp-label,
.position-label {
  text-transform: capitalize;
  font-size: var(--sp-ref-font-size-small);
}
</style>
